import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { Video } from '../../model/video';
import { loadVideos } from '../../action/video.actions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Meta, Title } from '@angular/platform-browser';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-product-video',
  templateUrl: './product-video.component.html',
  styleUrl: './product-video.component.scss'
})
export class ProductVideoComponent implements OnInit{
  videos: Video[];
  videoCategories = [
    { id: "1", name: 'Medeil' },
    { id: "2", name: 'Medeil Cloud POS' },
    { id: "3", name: 'Medeil Cloud HQ' },
    { id: "4", name: 'Hosbay' },
    { id: "5", name: 'Allotmed' }
  ];
  selectedVideo: Video | null = null;
  gifLoader: boolean;
    constructor(private store:Store<{video:{video:Video[]}}>,private snackBar: MatSnackBar,   private titleService: Title,
      private metaService: Meta,private sanitizer: DomSanitizer,private router: Router,private title:Title,private meta:Meta,@Inject(PLATFORM_ID) private platformId: Object){

      this.store.dispatch(loadVideos());
      this.gifLoader=true;
    }
  ngOnInit(): void {
    this.setSeoMeta()
    this.store.select((state:any) => state.video.loading).subscribe(loading => {
      this.gifLoader = loading;
    });

    this.store.select('video').subscribe((state: { video: Video[] }) => {
      this.videos = state.video.map(video => ({

        ...video,
        seotitle: this.generateSeoTitle(video.title),
        seodescription: this.generateSeoDescription(video.description),
        keywords: this.generateKeywords(video.title, video.description),
        embedUrl: this.getEmbedUrl(video.videolink)
      }));
      // this.gifLoader=false;
    });
    this.updateSeoMetadata(this.videos[0])
  }
  getVideosByCategory(categoryId: number) {
    return this.videos.filter((video:any) => video.category === categoryId);
  }
  copyToClipboard(videoLink: string) {
    navigator.clipboard.writeText(videoLink).then(() => {
      this.snackBar.open('Video link copied! Paste it on Instagram.', 'Close', { duration: 2000 });
    });
  }
  generateSeoTitle(title: string): string {
    return title
      ? title
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
          .replace(/\s+/g, '-') // Replace spaces with "-"
          .substring(0, 60) // Keep within SEO length
      : '';
  }

  // Generate SEO-friendly description (limited to 150 chars)
  generateSeoDescription(description: string): string {
    return description ? description.substring(0, 150) + '...' : '';
  }

  // Generate keywords from title & description
  generateKeywords(title: string, description: string): string {
    if (!title || !description) return '';

    let combinedText = title + ' ' + description;
    let words = combinedText
      .toLowerCase()
      .match(/\b(\w+)\b/g) // Extract words
      ?.filter(word => word.length > 3) // Remove short words
      .slice(0, 10); // Limit keywords to 10 words

    return words ? words.join(', ') : '';
  }

  // Function to update SEO when a video is selected
  updateSeoMetadata(video: Video): void {
    this.selectedVideo = video; // Set selected video

    // Update Page Title
    this.titleService.setTitle(video.seotitle || video.title);

    // Update Meta Tags
    this.metaService.updateTag({ name: 'description', content: video.seodescription || video.description });
    this.metaService.updateTag({ name: 'keywords', content: video.keywords });

    // Inject JSON-LD Schema
    this.injectJsonLdSchema(video);
  }

  // Inject JSON-LD Schema for Video SEO
  injectJsonLdSchema(video: Video): void {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": video.title,
      "description": video.seodescription || video.description,
      "thumbnailUrl": "https://example.com/default-thumbnail.jpg",
      "uploadDate": video.publishdate,
      "contentUrl": video.videolink
    });

    // Remove existing schema if present
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    document.head.appendChild(script);
  }
   isEmbed(videoUrl: string): boolean {
      // Check if it's a YouTube, Facebook, Instagram, or Twitter link
      return (
        videoUrl.includes('youtube.com') ||
        videoUrl.includes('youtu.be') ||
        videoUrl.includes('facebook.com') ||
        videoUrl.includes('instagram.com') ||
        videoUrl.includes('twitter.com')
      );
    }

    isDirectVideo(videoUrl: string): boolean {
      // Check if it's a direct video file (MP4, WebM, OGG)
      return videoUrl.match(/\.(mp4|webm|ogg)$/) !== null;
    }

    getEmbedUrl(videoUrl: string): SafeResourceUrl {
      let embedUrl = '';

      if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        embedUrl = videoUrl.replace('watch?v=', 'embed/');
      } else if (videoUrl.includes('facebook.com')) {
        embedUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(videoUrl)}&show_text=0&width=560`;
      } else if (videoUrl.includes('instagram.com')) {
        embedUrl = `https://www.instagram.com/p/${this.extractInstagramId(videoUrl)}/embed/`;
      } else if (videoUrl.includes('twitter.com')) {
        embedUrl = `https://twitframe.com/show?url=${encodeURIComponent(videoUrl)}`;
      } else {
        // If it's not an embed URL, return a safe URL for direct video
        return this.sanitizer.bypassSecurityTrustUrl(videoUrl);
      }

      return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    }

    extractInstagramId(url: string): string {
      const parts = url.split('/');
      return parts[parts.length - 2]; // Extracts the post/reel ID from the URL
    }
    viewPage(video: any) {

      this.router.navigate(['/more-details', video.seo_url], { state: { video } });
    }

      setSeoMeta() {
      const supportedLanguages = ['en', 'fr', 'es', 'pt'];
      let finalUrl = '';
    
      if (isPlatformBrowser(this.platformId)) {
        const origin = window.location.origin;
        const path = window.location.pathname;
        const parts = path.split('/');
    
        let lang = 'en'; // Default
        if (supportedLanguages.includes(parts[1])) {
          lang = parts[1];
        }
    
        // const fullPath = path.replace(/^\/[a-z]{2}/, '');
        // finalUrl = `${origin}/${lang}${fullPath}`;
        const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

      }
      
      const seoData = {
        title: 'Medeil: Best Medical Store and Chain Store Management Software Overview',
        description:
          'Discover how Medeil transforms medical and chain store management with powerful pharmacy software. Learn about key features, benefits, and how it helps streamline operations and boost business efficiency.',
        image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
        url: finalUrl,
        keywords:
          'Medeil, medical store software, chain pharmacy software, pharmacy management system, drugstore software, healthcare software'
      };
      
          this.title.setTitle(seoData.title);
          const metaTags = [
            { name: 'description', content: seoData.description },
            { name: 'keywords', content: seoData.keywords }, 
            { property: 'og:title', content: seoData.title },
            { property: 'og:description', content: seoData.description },
            { property: 'og:url', content: seoData.url },
            { property: 'og:type', content: 'website' },
            { property: 'og:image', content: seoData.image }
          ];
        
          metaTags.forEach(tag => this.meta.updateTag(tag));
        }
}
